(function() {
  'use strict';

  function RotatingAnnouncementBar(root) {
    this.root = root;
    this.track = root.querySelector('.rotating-announcement-bar__track');
    this.group = root.querySelector('.rotating-announcement-bar__group:not([aria-hidden])');
    this.marquee = root.querySelector('.rotating-announcement-bar__marquee');
    this.pauseOnHover = root.dataset.pauseOnHover === 'true';
    this.speedPx = parseFloat(root.dataset.speedPx) || 70;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.resizeTimer = null;
    this.eventsBound = false;

    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onFocusIn = this.onFocusIn.bind(this);
    this.onFocusOut = this.onFocusOut.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onVisibilityChange = this.onVisibilityChange.bind(this);

    if (!this.track || !this.group || !this.marquee) return;

    this.init();
  }

  RotatingAnnouncementBar.prototype.init = function() {
    if (this.reducedMotion) {
      this.root.classList.add('is-static');
      return;
    }

    var self = this;
    var start = function() {
      self.syncTrack();
      self.bindEvents();
    };

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(start).catch(start);
    } else {
      start();
    }
  };

  RotatingAnnouncementBar.prototype.prepareTrack = function() {
    var template = this.group;
    if (!template || !this.track || !this.marquee) return false;

    Array.from(this.track.querySelectorAll('.rotating-announcement-bar__group')).forEach(function(group) {
      if (group !== template) {
        group.remove();
      }
    });

    template.removeAttribute('aria-hidden');

    var marqueeWidth = this.marquee.clientWidth;
    if (marqueeWidth <= 0) return false;

    var groupWidth = Math.ceil(template.getBoundingClientRect().width);
    if (groupWidth <= 0) return false;

    var clone = template.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    this.track.appendChild(clone);

    var targetWidth = marqueeWidth + groupWidth * 2;
    var safety = 0;
    while (this.track.scrollWidth < targetWidth && safety < 24) {
      var extra = template.cloneNode(true);
      extra.setAttribute('aria-hidden', 'true');
      this.track.appendChild(extra);
      safety += 1;
    }

    this.root.style.setProperty('--rab-shift', '-' + groupWidth + 'px');
    return true;
  };

  RotatingAnnouncementBar.prototype.updateDuration = function() {
    if (!this.prepareTrack()) return;

    var shift = Math.abs(parseFloat(this.root.style.getPropertyValue('--rab-shift')) || 0);
    if (shift <= 0) return;

    var duration = shift / this.speedPx;
    duration = Math.max(duration, 8);
    this.root.style.setProperty('--rab-duration', duration + 's');
  };

  RotatingAnnouncementBar.prototype.syncTrack = function() {
    var self = this;
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        self.updateDuration();
      });
    });
  };

  RotatingAnnouncementBar.prototype.bindEvents = function() {
    if (this.eventsBound) return;
    this.eventsBound = true;

    window.addEventListener('resize', this.onResize);
    document.addEventListener('visibilitychange', this.onVisibilityChange);

    if (this.pauseOnHover) {
      this.root.addEventListener('mouseenter', this.onMouseEnter);
      this.root.addEventListener('mouseleave', this.onMouseLeave);
      this.root.addEventListener('focusin', this.onFocusIn);
      this.root.addEventListener('focusout', this.onFocusOut);
    }
  };

  RotatingAnnouncementBar.prototype.onResize = function() {
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(function() {
      this.syncTrack();
    }.bind(this), 150);
  };

  RotatingAnnouncementBar.prototype.onMouseEnter = function() {
    this.root.classList.add('is-paused');
  };

  RotatingAnnouncementBar.prototype.onMouseLeave = function() {
    this.root.classList.remove('is-paused');
  };

  RotatingAnnouncementBar.prototype.onFocusIn = function() {
    this.onMouseEnter();
  };

  RotatingAnnouncementBar.prototype.onFocusOut = function(event) {
    if (!this.root.contains(event.relatedTarget)) {
      this.onMouseLeave();
    }
  };

  RotatingAnnouncementBar.prototype.onVisibilityChange = function() {
    if (document.hidden) {
      this.root.classList.add('is-paused');
    } else {
      this.root.classList.remove('is-paused');
    }
  };

  function initAll(scope) {
    var context = scope || document;
    context.querySelectorAll('.rotating-announcement-bar[data-rab-init]').forEach(function(root) {
      if (root.__rabInstance && root.__rabInstance.destroy) {
        root.__rabInstance.destroy();
      }
      root.__rabInstance = new RotatingAnnouncementBar(root);
    });
  }

  RotatingAnnouncementBar.prototype.destroy = function() {
    window.removeEventListener('resize', this.onResize);
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
  };

  window.initRotatingAnnouncementBar = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initAll(event.target);
  });

  if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
    document.addEventListener('shopify:block:select', function() {
      initAll(document);
    });
    document.addEventListener('shopify:block:deselect', function() {
      initAll(document);
    });
  }
})();
